import { create } from "zustand";

export const useGeneralAppStore = create((set) => ({

  ws: null,
  hw:null,
  dispositivo: null,
  orientacion:window.matchMedia("(orientation: portrait)").matches ? "portrait" : "landscape",
  modals: [],
  loads: [],

  setOrientacion:(orientacion)=>{
    set({orientacion:orientacion})
  },
  setS:(ws,hs)=>{
    set({ws:ws,hs:hs})
  },
  setDispositivo:(nameDispositivo)=>{
    set({dispositivo:nameDispositivo})
  },
 

  handlerModal: ({ modal, modalName }) => {
    if (modal) {
      set((state) => ({
        modals: [...state.modals, modalName],
      }));
    } else {
      set((state) => ({
        modals: state.modals.filter((mod) => mod != modalName),
      }));
    }
  },

  handlerLoading: ({ loading, loadName }) => {
    if (loading) {
      set((state) => ({
        loads: [...state.loads, loadName],
      }));
    } else {
      set((state) => ({
        loads: state.loads.filter((lo) => lo != loadName),
      }));
    }
  },
}));
